import React from 'react';
import { Button } from '@mui/material';

export const Columns = (deleteCurrencyItem) => [
  {
    id: 'code',
    numeric: false,
    disablePadding: false,
    label: 'Mã',
    width: 10,
    sort: true,
    align: 'center',
  },
  {
    id: 'name',
    numeric: true,
    disablePadding: false,
    label: 'Đơn vị tiền tệ',
    align: 'center',
  },
  {
    id: 'note',
    numeric: true,
    disablePadding: false,
    label: 'Ghi Chú',
    align: 'center',
  },
  {
    id: 'actions',
    numeric: false,
    disablePadding: false,
    label: 'Thao tác',
    width: '10px',
    fixed: 'right',
    align: 'center',
    render: (row) => (
      <Button
        variant="contained"
        size="small"
        color="error"
        sx={{ borderRadius: '15px', textTransform: 'none' }}
        onClick={() => window.showConfirm(() => deleteCurrencyItem(row))}
      >
        Xoá
      </Button>
    ),
  },
];
